import { fromJS } from 'immutable';
import { resolvePartner } from '../../config';

// Resolved once at module load. Persists across logout: the root reducer
// resets state to Map() on LOG_OUT, which makes combineReducers re-initialize
// this slice from `initialState` — and `initialState` still holds the value
// we computed at boot. So the partner identity follows the hostname, not the
// session.
const resolvePartnerIdAtBoot = () => {
  try {
    return resolvePartner(window.location.hostname).partnerId;
  } catch {
    return 'sabo';
  }
};

export const initialState = fromJS({ id: resolvePartnerIdAtBoot() });

export default function partnerReducer(state = initialState) {
  return state;
}
